/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-constructed-context-values */
import React, {
  createContext, useContext, useEffect, useState,
} from 'react';

import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { useSelector } from 'react-redux';
import { CoreContextProps, CoreProviderProps } from './CoreContext.types';
import { AuthSlice } from '../../reducer';

const CoreContext = createContext<CoreContextProps>(undefined!);
export function useCore() {
  return useContext(CoreContext);
}

const inMemoryCache = new InMemoryCache({
  typePolicies: {
    Address: { keyFields: ['addressId'] },
    Billing: { keyFields: ['billingId'] },
    ChangeLogItem: { keyFields: ['changeLogId'] },
    Client: { keyFields: ['clientId'] },
    Contact: { keyFields: ['contactId'] },
    Department: { keyFields: ['departmentId'] },
    Invoice: { keyFields: ['invoiceId'] },
    Item: { keyFields: ['itemId'] },
    Job: { keyFields: ['jobId'] },
    JobApplication: { keyFields: ['jobApplicationId'] },
    Organization: { keyFields: ['organizationId'] },
    Payment: { keyFields: ['paymentId'] },
    Position: { keyFields: ['positionId'] },
    Staff: { keyFields: ['staffId'] },
  },
});

/**
 * Core Provider
 * @param param0
 * @returns
 */
export function CoreProvider({
  children,
  cache,
}: CoreProviderProps) {
  const [coreClient, setCoreClient] = useState<ApolloClient<NormalizedCacheObject>>();

  const appEnvId = useSelector((state: { auth: AuthSlice }) => state.auth.appEnvId);
  const currentUser = useSelector((state: { auth: AuthSlice }) => state.auth.currentUser);

  useEffect(() => {
    if (currentUser) {
      const httpLink = createHttpLink({
        uri: `${process.env.REACT_APP_CORE_EXPRESS_URL}`,
      });

      const authorizationHeader = currentUser?.token ? { authorization: `Bearer ${currentUser.token}` } : {};
      const appIdHeader = process.env.REACT_APP_ID ? { appid: process.env.REACT_APP_ID } : {};
      const appEnvIdHeader = appEnvId ? { appenvid: appEnvId } : {};

      const authLink = setContext((_, { headers }) => ({
        headers: {
          ...appEnvIdHeader,
          ...appIdHeader,
          ...authorizationHeader,
          ...headers,
        },
      }));

      const client = new ApolloClient({
        cache: cache ?? inMemoryCache,
        link: authLink.concat(httpLink),
        connectToDevTools: true,
      });

      client.resetStore();
      setCoreClient(client);
    } else {
      setCoreClient(undefined);
    }
  }, [currentUser, appEnvId]);

  return (
    <CoreContext.Provider
      value={{
        coreClient,
      }}
    >
      {children}
    </CoreContext.Provider>
  );
}
